<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.ultrasounds', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title">
                    <router-link :to="{ name: 'add-ultrasound' }" v-if="can">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>

                <template v-if="rows">

                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col col sm="6">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mUltrasounds"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table
                            id="ultrasounds-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mUltrasounds"
                    >
                        <!-- A virtual composite column for actions -->
                        <template slot="action" slot-scope="data">
                            <div class="row" v-if="data.item.isAuthor || hasAdminRole">
                                <div class="col-sm-6">
                                    <b-link :to="{ name: 'edit-ultrasound', params: { consultation: consultation, ultrasound: data.item.slug } }">
                                        <i class="fas fa-edit fa-2x edit-icon"></i>
                                    </b-link>
                                </div>

                                <div class="col-sm-6">
                                    <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.slug"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.ultrasounds', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }} {{ data.item.slug }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button class="secondary" @click="deleteUltrasound(data.item.slug)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                    <b-pagination
                            class="justify-content-center"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="ultrasounds-table"
                    ></b-pagination>
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "Ultrasounds",

        computed: {
            ...mapGetters(["ultrasounds", "hasAdminRole", "hasMedecinControleRole", "hasPraticienRole","hasAssistante"]),

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },

            mUltrasounds: function() {
                let uArray = [];

                _.forEach(this.ultrasounds, function(ultrasound) {
                    let u = {};

                    u.pays = ultrasound.pays;
                    u.date = moment(ultrasound.created_at).format('DD-MM-YYYY HH:mm');
                    u.id = ultrasound.id;
                    u.type = ultrasound.type;
                    u.ddr = ultrasound.ddr;
                    u.dpa = ultrasound.dpa;
                    u.slug = ultrasound.slug;
                    u.isAuthor = ultrasound.isAuthor;

                    uArray.push(u);
                });

                return uArray;
            },

            rows: function() {
                return this.mUltrasounds.length;
            }
        },

        data() {
            return {
                consultation: this.$route.params.consultation,
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                fields: [
                    {
                        key: 'type',
                        label: this.$i18n.t('message.typeOfUltrasound'),
                        sortable: true
                    },
                    {
                        key: 'ddr',
                        label: this.$i18n.t('message.ddr'),
                        sortable: true
                    },
                    {
                        key: 'dpa',
                        label: this.$i18n.t('message.dpa'),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getUltrasounds() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getUltrasounds', { args : args });
            },

            formattedDisplay (result) {
                return result.nom;
            },

            itemSelected(item) {
                this.$router.push({ name: 'ultrasound', params: { ultrasound: item.selectedObject.slug } });
            },

            rowSelected(items) {
                this.$router.push({ name: 'ultrasound', params: { ultrasound: items[0].slug } });
            },

            deleteUltrasound(ultrasound) {
                let self = this;

                let args = {
                    ultrasound: ultrasound
                };

                let successMessage = this.$i18n.t('message.ultrasoundDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteUltrasound', { args, index: ultrasound, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + ultrasound);
                    });
            }
        },

        mounted() {
            // Fetch ultrasound list
            this.getUltrasounds();
        }
    }
</script>

<style scoped>

</style>